import React from 'react';

const ServiceNowBannerSection = ({ imgs, text, title }) => {
    return (
        <section className="w-full bg-[#FFFFFF] overflow-hidden select-none text-left relative z-10">
            <div className="max-w-[1440px] w-full mx-auto px-5 sm:px-10 lg:px-[80px]">

                <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10 items-center">

                    <div className="w-full flex items-center justify-center lg:justify-start">
                        <div className="w-full max-w-[540px] aspect-[16/9] sm:aspect-[16/10] lg:aspect-[16/9] overflow-hidden rounded-none">
                            <img
                                src={imgs}
                                alt="ServiceNow Abstract Geometric Art"
                                className="w-full h-full object-cover object-center transform transition-transform duration-700 hover:scale-[1.03]"
                            />
                        </div>
                    </div>

                    <div className="w-full flex flex-col items-start justify-center">
                        <h2 className="text-[#01386A] font-sora font-[600] text-[20px] lg:text-[30px] leading-[1.25] tracking-tight mb-6 max-w-[480px]">
                            {title}
                        </h2>

                        <div className="w-full max-w-[540px]">
                            <p className="text-[#49577A] font-graphik text-[14px] lg:text-[16px] leading-relaxed font-[500]">
                                {text}
                            </p>
                        </div>
                    </div>

                </div>

            </div>
        </section>
    );
};

export default ServiceNowBannerSection;